//加载region下拉
export function initRegion(regionData, region) {
    let selectedRegionCode = region;
    let list = regionData;
    if (list.length === 0 && !selectedRegionCode) {
        return;
    }
    if (
        list.length > 0 &&
        !selectedRegionCode &&
        !_.find(list, (item) => item.regionCode === getRegion())
    ) {
        selectedRegionCode = list[0].regionCode;
    }
    console.log(selectedRegionCode, 'region');
    return window.__ksStorage__.initRegion(regionData, selectedRegionCode);
}

// 主机产品类型
// 100 云主机
// 139 专属宿主机虚机
// 277 GPU专属宿主机虚机
// 145 GPU云服务器
export const InstanceProductGroup = [100, 139, 145, 277];